import BetaUnsupportedModal from '@/modules/viewer/components/beta/BetaUnsupportedModal.vue';
import { useModal, ModalOptions } from '@/storybook/modal/useModal';

export const useBetaVersion = () => {
  const showBetaVersionModal = (modalOptions?: ModalOptions) => {
    const { open } = useModal(BetaUnsupportedModal, { ...modalOptions });
    open();
  };

  return { showBetaVersionModal };
};
